import React from 'react';

import { Body2, Subtitle1 } from '../Typography';

import styles from './index.module.scss';

export type InfoCardImage =
  | string
  | React.ComponentType<{ className?: string; 'aria-label'?: string }>;

export interface InfoCardProps {
  title: string;
  text: string;
  textColor?: string;
  imageLeft: InfoCardImage;
  imageLeftAlt?: string;
  imageRight?: InfoCardImage;
  imageRightAlt?: string;
}

const InfoCard: React.FC<InfoCardProps> = ({
  title,
  text,
  textColor,
  imageLeft: ImageLeft,
  imageLeftAlt,
  imageRight: ImageRight,
  imageRightAlt,
}) => {
  return (
    <div className={styles.wrapper}>
      {typeof ImageLeft === 'string' ? (
        <img className={styles.imageLeft} src={ImageLeft} alt={imageLeftAlt} />
      ) : (
        <ImageLeft className={styles.imageLeft} aria-label={imageLeftAlt} />
      )}
      <div className={styles.textWrapper}>
        <Subtitle1 className={styles.title}>{title}</Subtitle1>
        <Body2 className={styles.text} style={{ color: textColor }}>
          {text}
        </Body2>
      </div>
      {ImageRight &&
        (typeof ImageRight === 'string' ? (
          <img
            className={styles.imageRight}
            src={ImageRight}
            alt={imageRightAlt}
          />
        ) : (
          <ImageRight
            className={styles.imageRight}
            aria-label={imageRightAlt}
          />
        ))}
    </div>
  );
};

export default InfoCard;
